import type { AxiosError } from 'axios';

/**
 * Backend error bodies come in two shapes (errorHandler.middleware.ts):
 * - `{ message }` for errors thrown without a `code`
 * - `{ error: { code, message } }` for errors carrying a structured code
 *   (e.g. RENAME_CONFLICT, INVALID_MOVE, MOVE_FAILED, DELETE_FAILED)
 */
interface ApiErrorBody {
  message?: string;
  error?: { code?: string; message?: string };
}

const asAxiosError = (error: unknown) => error as AxiosError<ApiErrorBody>;

/** Server-supplied message from either error shape, or `fallback`. */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = asAxiosError(error).response?.data;
  return data?.error?.message ?? data?.message ?? fallback;
};

/** Structured error code when the server sent one, otherwise undefined. */
export const getApiErrorCode = (error: unknown): string | undefined => asAxiosError(error).response?.data?.error?.code;

/** HTTP status of a failed request, or undefined for network/timeout errors. */
export const getApiErrorStatus = (error: unknown): number | undefined => asAxiosError(error).response?.status;
